
import { Observable } from './druid/./druid/Observable';
import { retryWhen } from './druid/./druid/operator/retryWhen';

Observable.prototype.retryWhen = retryWhen;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    retryWhen: typeof retryWhen;
  }
}